import { NgModule } from '@angular/core';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ThemeToggleComponent } from './theme-toggle/theme-toggle.component';
import { SharedModule } from '../shared/modules/shared.module';
import { LayoutComponent } from './layout.component';
import {
  FolderCog,
  ChevronLeft,
  ChevronRight,
  Home,
  History,
  Newspaper,
  NotebookTabs,
  FileText,
  Briefcase,
  Hammer,
  PanelLeftClose,
  PanelLeftOpen,
  LucideAngularModule,
} from 'lucide-angular';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    ThemeToggleComponent,
    LayoutComponent,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    LayoutComponent,
  ],
  imports: [
    SharedModule,
    MatTooltipModule,
    LucideAngularModule.pick({
      FolderCog,
      ChevronLeft,
      ChevronRight,
      Home,
      History,
      Newspaper,
      NotebookTabs,
      FileText,
      Briefcase,
      Hammer,
      PanelLeftClose,
      PanelLeftOpen,
    }),
  ],
})
export class LayoutModule {}
